//@ts-ignore
import { Badge, Button, Checkbox, InputGroup, Avatar } from 'dsm-react-lib'
import { useEffect, useMemo, useState } from 'react'
import {
  IconSearch,
  IconUsers,
  IconChevronDown,
  IconTrash,
  IconDotsVertical,
  IconEdit,
  IconLayoutGrid,
  IconLayoutList,
  IconBrain,
  IconRobotFace,
  IconSquarePlus,
  IconHourglassLow,
  IconLock
} from '@tabler/icons-react'
import DataTable from 'react-data-table-component'
//@ts-ignore
import Select from 'react-select'
import DeleteAgentModal from '../modals/DeleteAgentModal'
import AgentCards from '../../Teams/AgentCards'
import ArcRoleSelectionModal from '../../AI-marketplace/ArcRoleSelectionModal'
import { AgentChatIcon, MonitorIcon } from '../icons/Icons'
import { setSelectedAgent } from '../../../../_redux/actions/chatbotActions'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { DropdownItem, Nav, NavItem, NavLink, UncontrolledDropdown } from 'reactstrap'
import {
  ButtonSpinner,
  DropdownMenuContainer,
  StyledDropdownToggle
} from '../../../../styles/common'
import { DropdownOption } from '../../Applications/styles'
import { getAvatarDisplayUrl, selectThemeColors } from '../../../../utility/Utils'
import { getAvailabilityBadgeProps } from '../../AgentsAndSkills/agentsSkillsConstants'
import { max } from 'lodash'
import { Role } from '../../../../utility/types'
import { useAgentArcService } from './agentArcService'

const VISIBILITY_TABS = [
  { value: 'all', label: 'All' },
  { value: 'Personal', label: 'Personal' },
  { value: 'Team', label: 'Team' },
  { value: 'Enterprise', label: 'Enterprise' }
]

const SORT_OPTIONS = [
  { value: 'recent', label: 'Most recently used' },
  { value: 'name-asc', label: 'Name (A-Z)' },
  { value: 'name-desc', label: 'Name (Z-A)' }
]

const MyAgents = ({ initialSelectedFilters = [] }: { initialSelectedFilters?: string[] } = {}) => {
  const [selectedFilters, setSelectedFilters] = useState<string[]>(initialSelectedFilters)
  const [filteredAgents, setFilteredAgents] = useState<any[]>([])
  const [deleteAgent, setDeleteAgent] = useState<any>({ isOpen: false, agent: null })
  const [viewType, setViewType] = useState<'grid' | 'list'>('grid')
  const [openFilterSidebar, setOpenFilterSidebar] = useState(false)
  const [searchValue, setSearchValue] = useState('')
  const [visibilityTab, setVisibilityTab] = useState('all')
  const [sortOption, setSortOption] = useState<any>(SORT_OPTIONS[0])
  // Add state and handler for row selection
  const [selectedRows, setSelectedRows] = useState<string[]>([])
  const selectAll = filteredAgents.length > 0 && selectedRows.length === filteredAgents.length
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { agentsList } = useSelector((state: any) => state.agentReducer)
  const { roles } = useSelector((state: any) => state.userContextReducer.userContext)
  const isCentraliAdmin = roles?.includes(Role.Admin)
  const [requestingAgentId, setRequestingAgentId] = useState<any>(null)
  const [arcRoleModal, setArcRoleModal] = useState<{ isOpen: boolean; agent: any }>({
    isOpen: false,
    agent: null
  })
  const { requestAgentArcAccess, getArcRoleOptions } = useAgentArcService()

  // Flattens metadata onto each agent and builds `arc` in the shape AgentCards/AI Marketplace expect
  const normalizedAgentsList = useMemo(
    () =>
      (agentsList || []).map((agent: any) => {
        const metadata = agent.metadata || {}
        // arcStatus arrives from the API as a JSON string, e.g. '{"isInProcess":true,"arcRoles":[]}'
        let arcStatus = metadata.arcStatus
        if (typeof arcStatus === 'string') {
          try {
            arcStatus = JSON.parse(arcStatus)
          } catch {
            arcStatus = undefined
          }
        }
        return {
          ...agent,
          ...metadata,
          uniqueName: metadata.uniqueName || agent.uniqueName,
          arcStatus,
          arc: arcStatus
            ? {
                isInProcess: Boolean(arcStatus.isInProcess),
                arcRoles: arcStatus.arcRoles || [],
                hideArcRoles: Boolean(arcStatus.hideArcRoles)
              }
            : agent.arc
        }
      }),
    [agentsList]
  )

  const submitArcRequest = async (agent: any, role?: string) => {
    setRequestingAgentId(agent.id)
    await requestAgentArcAccess(agent, role)
    setRequestingAgentId(null)
  }

  const onRequestArcAccess = (agent: any) => {
    const roleOptions = getArcRoleOptions(agent)
    if (roleOptions.length > 1) {
      setArcRoleModal({ isOpen: true, agent })
      return
    }
    submitArcRequest(agent, roleOptions[0]?.role)
  }

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedRows([])
    } else {
      setSelectedRows(filteredAgents.map((row: any) => row.id))
    }
  }

  const handleRowSelect = (rowId: string) => {
    setSelectedRows((prev) =>
      prev.includes(rowId) ? prev.filter((id) => id !== rowId) : [...prev, rowId]
    )
  }

  const columns = [
    // {
    //   name: (
    //     <Checkbox
    //       type="checkbox"
    //       name="select-all"
    //       id="select-all"
    //       checked={selectAll}
    //       onChange={() => handleSelectAll()}
    //       indeterminate={selectedRows.length > 0 && selectedRows.length < filteredAgents.length}
    //     />
    //   ),
    //   cell: (row: any) => (
    //     <Checkbox
    //       type="checkbox"
    //       name={`select-row-${row.id}`}
    //       id={`select-row-${row.id}`}
    //       checked={selectedRows.includes(row.id)}
    //       onChange={() => handleRowSelect(row.id)}
    //     />
    //   ),
    //   sortable: false,
    //   width: '50px'
    // },
    {
      name: '',
      selector: (row: any) => row.name,
      sortable: true,
      width: '20px',
      cell: (row: any) => (
        <span>
          {row.avatarUrl ? (
            <Avatar content={getAvatarDisplayUrl(row.avatarUrl)} size="30px" className="ml-0" />
          ) : (
            <div className="rounded-full w-[34px] h-[34px] flex items-center justify-center theme-avatar-placeholder ml-1">
              <IconRobotFace size={28} className="text-[var(--icon-muted)]" stroke={1.5} />
            </div>
          )}
        </span>
      )
    },
    {
      name: 'Agent name',
      selector: (row: any) => row.name,
      sortable: true,
      maxWidth: '700px',
      minWidth: '400px',
      cell: (row: any) => (
        <div className="flex flex-col ml-3 pl-2">
          <span className="card-header-text text-gray-800">{row.name}</span>
          <span className="caption-text text-gray-400 line-clamp-1 ellipsis">
            {row.description}
          </span>
        </div>
      )
    },
    {
      name: '',
      selector: (row: any) => row.name,
      sortable: true,
      width: '180px',
      cell: (row: any) =>
        row?.arc?.isInProcess ? (
          <span className="chat-icon-span">
            <Button
              className="p-50 py-0 cursor-not-allowed theme-warning-light-btn"
              color="warning"
              label="Pending"
              icon={<IconHourglassLow size={16} />}
              variant="outline"
              disabled
            />
          </span>
        ) : (row?.arc?.arcRoles?.length ?? 0) > 0 ? (
          <span className="chat-icon-span">
            <Button
              className="p-50 py-0 theme-accent-outline-btn"
              color="primary"
              label={requestingAgentId === row.id ? 'Requesting...' : 'Request'}
              icon={
                requestingAgentId === row.id ? (
                  <ButtonSpinner color="var(--color-primary)" />
                ) : (
                  <IconLock size={16} />
                )
              }
              variant="outline"
              disabled={requestingAgentId === row.id}
              onClick={(e: any) => {
                e.stopPropagation()
                onRequestArcAccess(row)
              }}
            />
          </span>
        ) : (
          <span className="chat-icon-span">
            <Button
              icon={<AgentChatIcon size={20} color="#fff" />}
              color="primary"
              label="Chat"
              className="p-50 py-0"
              onClick={() => {
                dispatch(setSelectedAgent({ ...row }))
                navigate('/chat', { state: { fromAgentCard: true } })
              }}
            />
          </span>
        )
    },
    // {
    //   name: '',
    //   selector: (row: any) => row.name,
    //   sortable: true,
    //   width: '10px',
    //   cell: (row: any) => (
    //     <span className="monitor-icon-span">
    //       <MonitorIcon size={20} color="#ABA7B7" />
    //     </span>
    //   )
    // },
    {
      name: '',
      selector: (row: any) => row.name,
      sortable: true,
      width: '120px',
      minWidth: '120px',
      cell: (row: any) =>
        row?.metadata?.userRole !== 'Member' &&
        (row.agentType !== 'Enterprise' || isCentraliAdmin) ? (
          <span className="verticalicon-span w-full flex justify-end">
            <div
              className="d-flex align-items-center pr-2 min-w-[56px] justify-end"
              onClick={(e: React.MouseEvent) => e.stopPropagation()}>
              <UncontrolledDropdown direction="start">
                <StyledDropdownToggle tag="span">
                  <IconDotsVertical size={24} />
                </StyledDropdownToggle>
                <DropdownMenuContainer $positionFixed={true} style={{ right: '0', left: 'auto' }}>
                  <DropdownItem
                    className="w-100 theme-dropdown-accent-item"
                    onClick={(e: React.MouseEvent) => {
                      e.stopPropagation()
                      navigate({
                        pathname: `/agents/edit-agent/${row.id}`
                      })
                    }}>
                    <DropdownOption className="flex items-center">
                      <IconEdit size={15} />
                      <span className="align-middle ms-50">Manage</span>
                    </DropdownOption>
                  </DropdownItem>
                  <DropdownItem
                    className="w-100 theme-dropdown-accent-item"
                    onClick={(e: React.MouseEvent) => {
                      e.stopPropagation()
                      navigate(`/agents/${row.id}/memories`)
                    }}>
                    <DropdownOption className="flex items-center">
                      <IconBrain size={15} stroke={1.5} />
                      <span className="align-middle ms-50">Memories</span>
                    </DropdownOption>
                  </DropdownItem>
                  <DropdownItem
                    className="w-100 theme-dropdown-danger-item"
                    onClick={() => {
                      setDeleteAgent({ isOpen: true, agent: row })
                    }}>
                    <DropdownOption className="flex items-center">
                      <IconTrash size={15} />
                      <span className="align-middle ms-50">Delete</span>
                    </DropdownOption>
                  </DropdownItem>
                </DropdownMenuContainer>
              </UncontrolledDropdown>
            </div>
          </span>
        ) : (
          <span className="verticalicon-span w-full flex justify-end">
            <div className="d-flex w-6 h-6" />
          </span>
        )
    },
    {
      name: 'Visibility',
      selector: (row: any) => row.agentType,
      sortable: true,
      minWidth: '100px',
      maxWidth: '200px',
      cell: (row: any) => (
        <div className="flex flex-row pl-1">
          <span className="caption-text">
            {row.agentType === 'Team' && (
              <Badge
                icon={<IconUsers size={16} color="white" />}
                label="Team"
                className="font-weight-normal"
                color="var(--team-agent)"
              />
            )}
            {row.agentType === 'Enterprise' && (
              <Badge
                icon={<IconUsers size={16} color="white" />}
                label="Enterprise"
                className="font-weight-normal"
                color="var(--enterprise-agent)"
              />
            )}
            {row.agentType === 'Personal' && (
              <Badge
                icon={<IconUsers size={16} color="white" />}
                label="Personal"
                className="font-weight-normal"
                color="var(--color-secondary)"
              />
            )}
          </span>
        </div>
      )
    },
    {
      name: 'Availability',
      selector: (row: any) => row?.metadata?.availabilityLabel,
      sortable: false,
      maxWidth: '150px',
      cell: (row: any) => {
        const availabilityBadge = getAvailabilityBadgeProps(row?.metadata?.availabilityLabel)
        return (
          availabilityBadge && (
            <div className="flex flex-row">
              <Badge
                type={availabilityBadge.type}
                variant={availabilityBadge.variant}
                color={availabilityBadge.color}
                label={availabilityBadge.label}
                className={availabilityBadge.className}
              />
            </div>
          )
        )
      }
    },
    {
      name: 'Source',
      selector: (row: any) => row?.source,
      sortable: false,
      minWidth: '150px',
      cell: (row: any) => (
        <div className="flex flex-row">
          <span className="caption-text text-gray-700">{row?.source || 'Centrali'}</span>
        </div>
      )
    }
    // {
    //   name: 'Skills',
    //   selector: (row: any) => row?.skills,
    //   minWidth: '300px',
    //   maxWidth: '300px',
    //   cell: (row: any) => (
    //     <div className="flex flex-row">
    //       {row?.skills?.slice(0, 3).map((skill: any, index: number) => (
    //         <Badge type="pill" key={index} label={skill} className="agent-tag" />
    //       ))}
    //       <span className="inline w-7 h-7">
    //         {row?.skills?.length > 3 ? (
    //           <Badge
    //             className="inline-flex mb-1 w-7 h-6 rounded-full font-semibold text-[12px] bg-primary/10 text-primary items-center justify-center"
    //             label={`+${row?.skills?.length - 3}`}
    //             variant="light"
    //             type="pill"
    //             color="primary"
    //           />
    //         ) : (
    //           // Empty placeholder to reserve space
    //           <span className="inline w-7 h-7" />
    //         )}
    //       </span>
    //     </div>
    //   )
    // },
    // {
    //   name: 'Plugins',
    //   selector: (row: any) => row?.plugins,
    //   minWidth: '200px',
    //   maxWidth: '200px',
    //   cell: (row: any) => (
    //     <div className="flex flex-row w-[32px] h-[32px] gap-[4px] ">
    //       {row?.plugins?.map((plugin: any, index: number) => (
    //         <img
    //           key={index}
    //           src={plugin?.logo}
    //           alt={plugin?.name}
    //           width={plugin?.width}
    //           height={plugin?.height}
    //         />
    //       ))}
    //     </div>
    //   )
    // }
  ]

  // Read search parameter from URL and populate searchValue on mount
  useEffect(() => {
    const searchParam = searchParams.get('search')
    if (searchParam) {
      setSearchValue(searchParam)
    }
  }, [searchParams])

  useEffect(() => {
    // Early return if no agents
    if (!normalizedAgentsList?.length) {
      setFilteredAgents([])
      return
    }

    let result = normalizedAgentsList.filter((agent: any) => !agent.isPersonalAssistant)

    // Search filter - early return if no matches
    if (searchValue) {
      const searchLower = searchValue.toLowerCase()
      result = result.filter(
        (agent: any) =>
          agent.name?.toLowerCase().includes(searchLower) ||
          agent.description?.toLowerCase().includes(searchLower)
      )

      // Early return if search yields no results
      if (result.length === 0) {
        setFilteredAgents([])
        return
      }
    }

    // Apply filters with optimized logic
    if (selectedFilters.length > 0) {
      const filterSet = new Set(selectedFilters)

      result = result.filter((agent: any) => {
        // Check agentType
        if (filterSet.has(agent.agentType)) return true

        // Check source
        if (filterSet.has(agent.source || 'Ali')) return true

        // Check skills/categories - only if agent has skills
        if (agent.skills?.length > 0) {
          return agent.skills.some((skill: string) => filterSet.has(skill))
        }

        return false
      })
    }
    setFilteredAgents(result)
  }, [normalizedAgentsList, searchValue])

  // Visibility tab filter applies to both grid and list views
  const visibilityFilteredAgents = useMemo(() => {
    if (visibilityTab === 'all') return filteredAgents
    return filteredAgents.filter((agent: any) => agent.agentType === visibilityTab)
  }, [filteredAgents, visibilityTab])

  // Sort by is grid-only - the list view keeps its own column sorting untouched
  const gridAgents = useMemo(() => {
    // 'recent' keeps the API's existing most-recently-used order as-is
    const [field, direction] = (sortOption?.value || '').split('-')
    if (field !== 'name') return visibilityFilteredAgents
    return [...visibilityFilteredAgents].sort((a: any, b: any) => {
      const aValue = (a?.name || '').toLowerCase()
      const bValue = (b?.name || '').toLowerCase()
      return direction === 'asc' ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue)
    })
  }, [visibilityFilteredAgents, sortOption])

  const displayAgents = viewType === 'grid' ? gridAgents : visibilityFilteredAgents

  const handleVisibilityTabChange = (tab: string) => {
    setVisibilityTab(tab)
  }

  return (
    <div className="w-full pl-1">
      <div className="d-flex align-items-center w-full justify-between">
        <Nav tabs className="mb-0 border-0">
          {VISIBILITY_TABS.map((tab) => (
            <NavItem
              key={tab.value}
              className={`pt-[6px] px-[5px] mb-[10px] ${
                visibilityTab === tab.value ? 'border-b-4 border-[var(--color-primary)] mb-0' : ''
              }`}>
              <NavLink
                onClick={() => handleVisibilityTabChange(tab.value)}
                className={`cursor-pointer flex items-center text-lg pb-0 ${
                  visibilityTab === tab.value ? 'text-primary' : ''
                }`}>
                {tab.label}
              </NavLink>
            </NavItem>
          ))}
        </Nav>

        <div className="d-flex justify-end gap-1">
          <Button
            icon={<IconSquarePlus size={20} />}
            label="Add agent"
            color="primary"
            size="small"
            onClick={() => navigate('/agents/add-agent')}
          />
          <div className="flex gap-25 items-center justify-center">
            <Button
              variant="flat"
              onClick={() => setViewType('grid')}
              title="Grid View"
              className={`h-fit !p-[2px] ${
                viewType === 'grid' ? 'theme-brand-accent-bold' : 'text-muted'
              }`}>
              <IconLayoutGrid
                size={26}
                className={viewType === 'grid' ? 'theme-brand-accent-bold' : 'text-gray-400'}
              />
            </Button>
            <Button
              onClick={() => setViewType('list')}
              title="List View"
              variant="flat"
              className={`h-fit !p-[3px] ${
                viewType === 'list' ? 'theme-brand-accent-bold' : 'text-muted'
              }`}>
              <IconLayoutList
                size={24}
                className={viewType === 'list' ? 'theme-brand-accent-bold' : 'text-gray-400'}
              />
            </Button>
          </div>
        </div>
      </div>

      <div className="flex items-center w-full justify-between mt-1 mb-1">
        <InputGroup
          data-testid="search-input"
          className="w-50"
          addon={<IconSearch size={14} />}
          addonPosition="start"
          addonType="merged"
          placeholder="Search for agents..."
          value={searchValue}
          onChange={(e: any) => setSearchValue(e.target.value)}
          onClear={() => setSearchValue('')}
        />
        {viewType === 'grid' && (
          <Select
            isClearable={false}
            isSearchable={false}
            name="sort-agents"
            options={SORT_OPTIONS}
            value={sortOption}
            onChange={(selected: any) => setSortOption(selected)}
            classNamePrefix="select"
            placeholder="Sort by"
            theme={selectThemeColors}
            className="w-[180px]"
            menuPlacement="auto"
            menuPortalTarget={document.body}
            styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
          />
        )}
      </div>

      {/* Empty State */}
      {displayAgents?.length === 0 ? (
        <div className="text-center py-12">
          <h3 className="text-2xl font-medium text-gray-900 mb-2">🔍 No agents found</h3>
          <p className="text-gray-600">Try adjusting your search or create a new agent.</p>
        </div>
      ) : (
        <div className="flex w-full flex-wrap pb-2 my-1">
          {/* Agents Grid */}
          {viewType === 'grid' ? (
            displayAgents?.map((agent: any, index: number) => (
              <AgentCards key={agent.id || index} agentData={[agent]} />
            ))
          ) : (
            <DataTable
              noHeader
              data={displayAgents}
              columns={columns}
              className="react-dataTable data-table mt-2 no-header-border"
              sortIcon={<IconChevronDown size={10} />}
              paginationServerOptions={{
                persistSelectedOnPageChange: false,
                persistSelectedOnSort: false
              }}
            />
          )}
          {deleteAgent.isOpen && (
            <DeleteAgentModal
              isOpen={deleteAgent.isOpen}
              toggle={() => setDeleteAgent({ isOpen: false, agent: null })}
              agent={deleteAgent.agent}
            />
          )}
          {arcRoleModal.isOpen && (
            <ArcRoleSelectionModal
              isOpen={arcRoleModal.isOpen}
              toggle={() => setArcRoleModal({ isOpen: false, agent: null })}
              roles={getArcRoleOptions(arcRoleModal.agent)}
              isLoading={requestingAgentId === arcRoleModal.agent?.id}
              onConfirm={(role) => {
                const agent = arcRoleModal.agent
                setArcRoleModal({ isOpen: false, agent: null })
                submitArcRequest(agent, role)
              }}
            />
          )}
        </div>
      )}
    </div>
  )
}
export default MyAgents
